import { Text, TextAppearance, TextColor } from "@ngw6/us-components";
import React from "react";
import {
  DealerDetailIcon,
  DealerDetailText,
  DealerDetailWrapper,
  StyledIcon,
} from "./styled";

interface DealerInformationDetailProps {
  Icon: any;
  label1?: string | JSX.Element;
  label2?: string | JSX.Element;
}
const DealerInformationDetail = ({
  label1,
  label2,
  Icon,
}: DealerInformationDetailProps): JSX.Element => (
  <DealerDetailWrapper>
    <DealerDetailIcon>
      <StyledIcon>
        <Icon iconSize={15} />
      </StyledIcon>
    </DealerDetailIcon>
    <DealerDetailText>
      <Text color={TextColor.inherit} appearance={TextAppearance.copy100}>
        {label1}
      </Text>
      <Text color={TextColor.inherit} appearance={TextAppearance.copy100}>
        {label2}
      </Text>
    </DealerDetailText>
  </DealerDetailWrapper>
);

export default DealerInformationDetail;
